import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Modal, Button ,Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { 
    getproductCurrency, 
    createproductCurrency, 
    updateproductCurrency, 
    deleteproductCurrency 
} from '../../actions/currencyAction';
import MessageModal from "../Pages/MessageModel"; // Success message ke liye

const currencyFormat = [
  { id: "1", currency: "Dollar", Symbol: "$" },
  { id: "2", currency: "Euro", Symbol: "€" },
  { id: "3", currency: "Dutch Florin", Symbol: "ƒ" },
  { id: "4", currency: "Cent Sign", Symbol: "¢" },
  { id: "5", currency: "British Pound", Symbol: "£" },
  { id: "6", currency: "General Currency", Symbol: "¤" },
  { id: "7", currency: "Japanese Yen", Symbol: "¥" },
  { id: "8", currency: "Square Yuan", Symbol: "㍐" },
  { id: "9", currency: "Armenian Dram", Symbol: "֏" },
  { id: "10", currency: "Afghani", Symbol: "؋" },
  { id: "11", currency: "Bengali Rupee", Symbol: "৲" },
  { id: "12", currency: "Bengali Rupee", Symbol: "৳" },
  { id: "13", currency: "Gujarati Rupee", Symbol: "૱" },
  { id: "14", currency: "Tamil Rupee", Symbol: "௹" },
  { id: "15", currency: "Thai Baht", Symbol: "฿" },
  { id: "16", currency: "Korean Won", Symbol: "원" },
  { id: "17", currency: "Khmer Symbol Riel", Symbol: "៛" },
  { id: "18", currency: "Saudi Arabiya Rial", Symbol: "﷼" },
  { id: "19", currency: "Old Euro Currency", Symbol: "₠" },
  { id: "20", currency: "Colon", Symbol: "₡" },
  { id: "21", currency: "Cruzeiro", Symbol: "₢" },
  { id: "22", currency: "French Franc", Symbol: "₣" },
  { id: "23", currency: "Lira", Symbol: "₤" },
  { id: "24", currency: "Mill", Symbol: "₥" },
  { id: "25", currency: "Nigerian Naira", Symbol: "₦" },
  { id: "26", currency: "Spanish Peseta", Symbol: "₧" },
  { id: "27", currency: "Old Indian Rupee", Symbol: "₨" },
  { id: "28", currency: "South Korean Won", Symbol: "₩" },
  { id: "29", currency: "Israeli New Sheqel", Symbol: "₪" },
  { id: "30", currency: "Vietnamese Dong", Symbol: "₫" },
  { id: "31", currency: "Laos Kip", Symbol: "₭" },
  { id: "32", currency: "Mongolian Tugrik", Symbol: "₮" },
  { id: "33", currency: "Greece Drachma", Symbol: "₯" },
  { id: "34", currency: "German Penny", Symbol: "₰" },
  { id: "35", currency: "Philippine Peso", Symbol: "₱" },
  { id: "36", currency: "Paraguayan Guarani", Symbol: "₲" },
  { id: "37", currency: "Argentine Austral", Symbol: "₳" },
  { id: "38", currency: "Ukrainian Hryvnia", Symbol: "₴" },
  { id: "39", currency: "Ghana Cedi", Symbol: "₵" },
  { id: "40", currency: "Old Livre Tournois", Symbol: "₶" },
  { id: "41", currency: "Esperanto Spesmilo", Symbol: "₷" },
  { id: "42", currency: "Tenge", Symbol: "₸" },
  { id: "43", currency: "Indian Rupee", Symbol: "₹" },
  { id: "44", currency: "Turkish Lira", Symbol: "₺" },
  { id: "45", currency: "Nordic", Symbol: "₻" },
  { id: "46", currency: "Azerbaijan Manat", Symbol: "₼" },
  { id: "47", currency: "Russian Ruble", Symbol: "₽" },
  { id: "48", currency: "Georgia Lari", Symbol: "₾" },
  { id: "49", currency: "Bitcoin", Symbol: "₿" },
];
const CurrencySettings = () => {
    const dispatch = useDispatch();
    
    // Redux State
    const { currencyList } = useSelector(state => state.currencyReducer || { currencyList: [] });
    
    // Local State
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("None");
    const [showMessageModal, setShowMessageModal] = useState(false);

    const [formData, setFormData] = useState({
        id: '',
        currency_name: '',
        currency_code: '',
        symbol: '',
        exchange_rate: '1.00',
        decimal_places: 2,
        status: 'Active',
        is_default: 0
    });

   useEffect(() => {
    // getCurrencies ko badal kar getproductCurrency karein
    const hospital_id = localStorage.getItem('hospitalCode'); 
    dispatch(getproductCurrency({hospital_id})); 
}, [dispatch]);

    // Filter Logic (Same as Offer section)
    const filteredCurrencies = useMemo(() => {
        return (currencyList || []).filter(curr => {
            const matchesSearch = curr.currency_name.toLowerCase().includes(search.toLowerCase()) || 
                                 curr.currency_code.toLowerCase().includes(search.toLowerCase());
            const matchesStatus = statusFilter === "None" || curr.status === statusFilter;
            return matchesSearch && matchesStatus;
        }).sort((a, b) => b.id - a.id);
    }, [currencyList, search, statusFilter]);

    const handleClose = () => {
        setShowModal(false);
        setEditMode(false);
        setFormData({ id: '', currency_name: '', currency_code: '', symbol: '', exchange_rate: '1.00', decimal_places: 2, status: 'Active', is_default: 0 });
    };

    const handleShow = () => setShowModal(true);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
        }));
    };
const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 1. Hospital ID ko localStorage se nikal kar number mein convert karein
    const h_id = parseInt(localStorage.getItem('hospitalCode'), 10);

    // 2. Exact Payload taiyar karein jo aapne bataya hai
    const payload = {
        id: formData.id,                      // Update ke liye zaroori
        hospital_id: h_id,                   // underscore wala key
        currency_name: formData.currency_name,
        currency_code: formData.currency_code,
        symbol: formData.symbol,
        exchange_rate: parseFloat(formData.exchange_rate),
        decimal_places: parseInt(formData.decimal_places, 10),
        is_default: formData.is_default,     // 1 ya 0
        status: formData.status
    };

    try {
        if (editMode) {
            // Update operation
            await dispatch(updateproductCurrency(payload));
        } else {
            // Create operation (Create mein 'id' ko delete kar sakte hain agar backend generate karta hai)
            const { id, ...createPayload } = payload; 
            await dispatch(createproductCurrency(createPayload));
        }
        setShowMessageModal(true);
        handleClose();
    } catch (error) {
        console.error("Operation failed", error);
    }
};

// --- Line 382 ke paas handleDelete update karein ---
const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this currency?")) {
        // Backend id mangta hai
        dispatch(deleteproductCurrency({ id: id }));
    }
};

   const handleEdit = (item) => {
    setEditMode(true);
    setFormData({
        id: item.id,
        currency_name: item.currency_name,
        currency_code: item.currency_code,
        symbol: item.symbol,
        exchange_rate: item.exchange_rate,
        decimal_places: item.decimal_places,
        status: item.status,
        is_default: item.is_default
    });
    setShowModal(true);
};


    return (
        <div className="page-wrapper ml-0">
            <div className="content-container">
                
                {/* Header & Breadcrumbs (Offer Style) */}
                <div className="page-header filter-bar rounded">
                    <div className="row align-items-center">
                        <div className="col">
                            <h4 className="page-title">Currency Settings</h4>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard">Admin Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Currencies</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Filters Row (Offer Style) */}
                <div className="d-flex gap-2 flex-wrap mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Currency Name or Code"
                        style={{ maxWidth: 300 }}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <select
                        className="form-select"
                        style={{ maxWidth: 150 }}
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <option value="None">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>

                    <button
                        className="btn btn-info rounded-pill my-1"
                        onClick={handleShow}
                    >
                        Add Currency
                    </button>
                </div>

                {/* Table (Offer Style) */}
                <div className="card">
                    <div className="card-body">
                        <Table hover responsive className="align-middle">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Currency Name</th>
                                    <th>Code</th>
                                    <th>Symbol</th>
                                    <th>Exchange Rate</th>
                                    <th>Status</th>
                                    <th>Base</th>
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCurrencies.length === 0 ? (
                                    <tr>
                                        <td colSpan={8} className="text-center text-muted py-5">
                                            No currencies found.
                                        </td>
                                    </tr>
                                ) : (
                                    filteredCurrencies.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.currency_name}</td>
                                            <td><Badge bg="light" text="dark">{item.currency_code}</Badge></td>
                                            <td style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{item.symbol}</td>
                                            <td>{item.exchange_rate}</td>
                                            <td>
                                                <span className={item.status === "Active" ? "publish-label" : "unpublish-label"}>
                                                    {item.status}
                                                </span>
                                            </td>
                                            <td>
                                                {item.is_default === 1 ? 
                                                    <Badge bg="success">Yes</Badge> : 
                                                    <Badge bg="secondary">No</Badge>
                                                }
                                            </td>
                                            <td className="text-end">
                                                <button 
                                                    className="i-btn-edit me-2" 
                                                    onClick={() => handleEdit(item)}
                                                ></button>
                                                <button 
                                                    className="i-btn-delete" 
                                                    onClick={() => handleDelete(item.id)}
                                                ></button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>

                {/* Add/Edit Modal (Offer Style) */}
                <Modal show={showModal} onHide={handleClose} centered size="lg">
                    <Modal.Header className='bg-info text-white' closeButton>
                        <Modal.Title>{editMode ? 'Edit Currency' : 'Add New Currency'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit} className="p-2">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Currency Name</label>
                                    <input type="text" className="form-control" name="currency_name" value={formData.currency_name} onChange={handleChange} required />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Currency Code (Short Name)</label>
                                    <input type="text" className="form-control" name="currency_code" value={formData.currency_code} onChange={handleChange} required placeholder="e.g. USD" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Symbol</label>
                                    <select className="form-select" name="symbol" value={formData.symbol} onChange={handleChange} required>
                                        <option value="">Select Symbol</option>
                                        {currencyFormat.map(curr => (
                                            <option key={curr.id} value={curr.Symbol}>{curr.Symbol} - {curr.currency}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Exchange Rate</label>
                                    <input type="number" step="0.0001" className="form-control" name="exchange_rate" value={formData.exchange_rate} onChange={handleChange} required />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Decimal Places</label>
                                    <input type="number" className="form-control" name="decimal_places" value={formData.decimal_places} onChange={handleChange} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Status</label>
                                    <select className="form-select" name="status" value={formData.status} onChange={handleChange}>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" name="is_default" checked={formData.is_default === 1} onChange={handleChange} id="baseCurrSwitch" />
                                        <label className="form-check-label fw-bold pl-4" htmlFor="baseCurrSwitch">Set as Base Currency?</label>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button type="button" className="btn btn-danger rounded-pill px-4" onClick={handleClose}>Cancel</button>
                                <button type="submit" className="btn btn-info rounded-pill px-4 text-white">
                                    {editMode ? "Update Currency" : "Save Currency"}
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>

                {/* Success Message Modal */}
                <MessageModal
                    show={showMessageModal}
                    onClose={() => setShowMessageModal(false)}
                    title="Success!"
                    message={`Currency ${editMode ? 'Updated' : 'Added'} Successfully`}
                    variant="success"
                />

            </div>
        </div>
    );
};

export default CurrencySettings;









































